var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary qt-loader-mini qt-loader-right",class:{ 'qt-loader': _vm.loading },attrs:{"type":"submit","disabled":_vm.loading},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }